import { IPerson, Person } from '@/models/person/person'
import { Api } from './api'

export async function getPersonById (personId: string): Promise<Person> {
  const person = await Api.get<IPerson>(`${process.env.ACADEMIC_API_ENDPOINT}/v1/people/${personId}`)
  return new Person(person)
}
